export default {
	Approved: 1,
	Denied: 2,
	InviteSent: 3,
	Active: 4,
	Deactivated: 5,
	InviteExpired: 6,
	PendingApproval: 7,
	PendingUserRegistration: 8,
}


// WEBPACK FOOTER //
// ./src/utils/constants/userStatus.js